import { __decorate } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ConfigOauthService, ApiService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

const SPE_VIEW_N_ACCOUNT = '/spe-view-n-account';
let SpeViewNAccountProxy = class SpeViewNAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getMyData(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/account-data/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getMyDataReduced(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/account-data/reduced/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getAccountPaymentPerson(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/account-payment-person/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getAccountPayment(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/account-data/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getWhiteLabelData(uuidWhiteLabel) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/whiteLabel/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
    personalData(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/personal-data/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
};
SpeViewNAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeViewNAccountProxy = __decorate([
    Injectable()
], SpeViewNAccountProxy);

let UiPxMyDataModule = class UiPxMyDataModule {
};
UiPxMyDataModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [ConfigService, SpeViewNAccountProxy]
    })
], UiPxMyDataModule);

var DeletedEnum;
(function (DeletedEnum) {
    DeletedEnum["FALSE"] = "FALSE";
    DeletedEnum["TRUE"] = "TRUE";
})(DeletedEnum || (DeletedEnum = {}));

/*
 * Public API Surface of ui-px-user-account
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ConfigService, DeletedEnum, SpeViewNAccountProxy, UiPxMyDataModule };
//# sourceMappingURL=wlp-ui-px-my-data.js.map
